
import { Component, Prop, Vue } from 'vue-property-decorator';
import SettingEntity from '@/services/Internal-Tickets/interfaces/setting.entity';
import InternalTicketsRepositoryInterface, { SettingType } from '@/services/Internal-Tickets/interfaces';

@Component({
  inject: ['internalTicketsRepository']
})
export default class TicketSettingsDeleteDialog extends Vue{
  @Prop() private readonly setting!: SettingEntity;
  @Prop() private readonly type: SettingType
  @Prop() private readonly visible: boolean

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  get message(): string {
    return `Are you sure you want to remove ${this.setting.name}?`;
  }

  private destroyComponent(): void {
    this.$emit('cancelDeleteDialog');
  }

  private async deleteSetting() {
    try {
      await this.internalTicketsRepository.deleteSetting(this.type,this.setting.id)
      this.$successDialog.show(`Setting ${this.setting.name} has been removed.`);
      this.$emit('refreshSetting',this.type)
    }catch (e) {
      this.$errorDialog.show('Error updating setting: ' + e.message);
    }
  }
}

